// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".blue[data-v-54d2f15a]{color:#0062d4}.bg-image[data-v-54d2f15a]{max-width:150px;max-height:150px}", ""]);
// Exports
module.exports = exports;
